import moment from 'moment';
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ScrollView, Text, View } from 'react-native'
import { useSelector } from 'react-redux';
import { useCssStyle } from '../../customHook/getCssStyle';
import { formatLocalTime } from '../../js/utility';
import { getCleanUrl, toBool } from '../../utils/Helper';
import { ImageComp } from '../../components/Image/Image';
import HeaderWithBack from '../../components/Header/headerWithBack';
import CustomPressable from '../../components/customPressable/customPressable';
import ShowDeprecatedAddonPopup from './showDeprecatedAddonPopup';
import { HEART } from '../../assets';

const SpaBookingUpdate = (props) => {
    const { currentWidget, updateReservationDetails, bookingObj, shouldProceedOnDeprecatedAddonsWarning, handleNext, handleGoBack } = props;

    const { t } = useTranslation();
    const getStyles = useCssStyle();

    const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
    const currencyCode = currencyDetails.code;

    const { extraConfigParam } = useSelector(state => state.deviceConfigSlice);
    const dateFormat = extraConfigParam?.DATE_FORMAT;
    const TIME_FORMAT = extraConfigParam?.TIME_FORMAT_MERIDIEM || false;



    return (
        <View style={getStyles(['widgetRootContainer', 'spaBookingRootContainer'])} id='spaBookingRootContainer'>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />
            
            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'spaBookingMainContainer'])} 
                showsVerticalScrollIndicator={false}
                id='spaBookingMainContainer'
            >
                <View style={getStyles(['widgetmainContainerHeaderContainer', 'spaBookingHeaderContainer'])} id='spaBookingHeaderContainer'>
                    {
                        currentWidget?.widgetHeaderImageUrl && 
                            <ImageComp
                                source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} 
                                style={getStyles(['widgetmainContainerHeaderImg', 'spaBookingHeaderImg'])} id={"spaBookingHeaderImg"}
                            />
                    }
                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'spaBookingHeaderTitleContainer'])} id='spaBookingHeaderTitleContainer'>
                        <ImageComp source={HEART} style={getStyles(["spaBookingHeaderTitleImage"])} id="spaBookingHeaderTitleImage"/>

                        <Text style={getStyles(['widgetmainContainerHeaderTitle', 'spaBookingHeaderTitle'])} id='spaBookingHeaderTitle'>
                            {t("spaBooking.booking_overview")}
                        </Text>
                    </View>
                </View>

                <View style={getStyles(['widgetmainContainerChildContainer', 'spaBookingMainContainerChildContainer'])} >
                    <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                        <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                            {t("spaBooking.date")}
                        </Text>

                        <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                            {moment(new Date(updateReservationDetails.date)).format(dateFormat.toUpperCase())}
                        </Text>
                    </View>

                    <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                        <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                            {t("spaBooking.time")}
                        </Text>

                        <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                            {formatLocalTime(new Date(updateReservationDetails.date), toBool(TIME_FORMAT))}
                        </Text>
                    </View>


                    <View style={getStyles([""])}>
                        <Text style={getStyles([""])}>{t("spaBooking.details")}</Text>

                        <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                            <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                                {t("spaBooking.serviceName")}
                            </Text>
                            <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                {updateReservationDetails.serviceName || updateReservationDetails.lines[0].serviceName || ''}
                            </Text>
                        </View>

                        <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                            <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                                {t("spaBooking.locationName")}
                            </Text>
                            <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                {updateReservationDetails.locationName || ''}
                            </Text>
                        </View>

                        <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                            <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                                {t("spaBooking.therapist")}
                            </Text>
                            <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                {updateReservationDetails.lines[0].technician.fullNameDisplayed || ''}
                            </Text>
                        </View>

                        {updateReservationDetails.lines[0].technician.gender && ['M', 'F'].includes(updateReservationDetails.lines[0].technician.gender) &&
                            <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                                <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                                    {t("spaBooking.therapist_gender")}
                                </Text>
                                <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                    {updateReservationDetails.lines[0].technician.gender == 'F' ? "Female" : "Male"}
                                </Text>
                            </View>
                        }
                        <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                            <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                                {t("spaBooking.duration")}
                            </Text>
                            <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                {`${updateReservationDetails?.lines?.[0]?.duration} ${"minutes"}`}
                            </Text>
                        </View>

                        {updateReservationDetails.lines[0].technician &&  
                        <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                            <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>{t("spaBooking.base_price")}{" "}</Text>
                            <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                {`${currencyCode} ${updateReservationDetails.lines[0].price - (updateReservationDetails.lines[0].technician.price + (
                                    updateReservationDetails.lines[0].addOn && Array.isArray(updateReservationDetails.lines[0].addOn) && updateReservationDetails.lines[0].addOn.length > 0 
                                    ? updateReservationDetails.lines[0].addOn.reduce((acc, curr) => { return acc + curr.price; }, 0) : 0)
                            )}`}
                            </Text>
                        </View>
                        }


                        {updateReservationDetails?.lines?.[0]?.technician &&
                            <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                                <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'> {t("spaBooking.therapist_cost")}{" "}</Text>
                                <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                    {`${currencyCode} ${updateReservationDetails.lines[0].technician.price}`}
                                </Text>
                            </View>
                        }

                        <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                            <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                                {t("spaBooking.enhancements") + " [" + (updateReservationDetails?.lines?.[0]?.addOn && Array.isArray(updateReservationDetails.lines[0].addOn) && updateReservationDetails.lines[0].addOn.length > 0
                                    ? updateReservationDetails.lines[0].addOn.reduce((acc, curr, index) => {

                                        if (updateReservationDetails.lines[0].addOn.length - 1 != index) {
                                            return acc + curr.serviceName + ", "
                                        }
                                        return acc + curr.serviceName;
                                    }, "")
                                    : "No enhancement opted ") + "]"
                                }
                            </Text>

                            <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                {currencyCode}{" "}{updateReservationDetails.lines?.[0]?.addOn && Array.isArray(updateReservationDetails.lines[0].addOn) && updateReservationDetails.lines[0].addOn.length > 0 ? updateReservationDetails.lines[0].addOn.reduce((acc, curr) => { return acc + curr.price; }, 0) : 0}
                            </Text>
                        </View>
                        
                        {updateReservationDetails.lines?.[0] &&
                            <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                                <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                                    {t("spaBooking.total_cost")}{" "}
                                </Text>

                                <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                    {`${currencyCode} ${updateReservationDetails.lines[0].price }`}
                                    <Text style={getStyles([""])}>{t("spaBooking.per_person")}</Text>
                                </Text>
                            </View>
                        }

                        {updateReservationDetails.customerNotes &&
                            <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                                <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'> {t("spaBooking.guest_notes")}{" "}</Text>
                                <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                    {updateReservationDetails.customerNotes}
                                </Text>
                            </View>
                        }

                    </View>



                </View>
            </ScrollView>


            <View id='spaBookingNextButtonContainer' style={getStyles(['spaBookingNextButtonContainer'])}>
                <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleNext} id="primaryBtn">
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
                        {t("spaBooking.edit_reservation_button")}
                    </Text>
                </CustomPressable>

                {/* <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleGoBack}>
                    <Text style={getStyles(['secondaryBtnTxt'])}>
                        {t("spaBooking.back")}
                    </Text>
                </CustomPressable> */}
            </View>

            {bookingObj?.showDeprecatedAddonWarning &&
                <ShowDeprecatedAddonPopup
                    message={`Some of enhancements [${bookingObj?.deprecatedAddonList.reduce((acc, curr, index) => {
                        let s = curr.serviceName;
                        if (bookingObj?.deprecatedAddonList.length - 1 != index) s = s + ", ";
                        return acc + s;
                    }, "")}] of this reservation are no longer available. If you proceed with updation of this reservation, you can loose those enhancement(s).`}
                    handleNext={() => { shouldProceedOnDeprecatedAddonsWarning(false) }}
                    handleGoBack={() => { shouldProceedOnDeprecatedAddonsWarning(true) }} 
                />
            }
        </View>
    )
}

export default SpaBookingUpdate
